import * as React from "react";

import { AppContext } from "./AppContext";
import { makeAppContextValue } from "./makeAppContextValue";

export interface AppFeatureManagerProps {
  isExperimentalFeatureEnabled: (feature: string) => boolean;
  isPlatformFeatureEnabled?: (feature: string) => boolean;
  getExperimentalFeatureIntValue?: (
    feature: string,
    defaultValue: number
  ) => number;
}

/**
 * Component that provides its children an ability to check for experiment feature gate via context.
 * Use this instead of specifying `AppContext.Provider` directly.
 *
 * If using both `AppFeatureManager` and `AppTooltipManager`, ensure `AppTooltipManager` is a
 * descendant of `AppFeatureManager`.
 */
export const AppFeatureManager = ({
  isExperimentalFeatureEnabled,
  isPlatformFeatureEnabled,
  getExperimentalFeatureIntValue,
  children,
}: React.PropsWithChildren<AppFeatureManagerProps>) => {
  return (
    <AppContext.Consumer>
      {(context) => (
        <AppContext.Provider
          value={makeAppContextValue(
            isExperimentalFeatureEnabled,
            context.setTooltipElement,
            context.updateTooltipsHidden,
            context.appWindow,
            isPlatformFeatureEnabled,
            getExperimentalFeatureIntValue
          )}
        >
          {children}
        </AppContext.Provider>
      )}
    </AppContext.Consumer>
  );
};
